/**
 * ConfirmBattleSettings use case: starts battle with draft settings.
 * Transitions scene "settings" → "game".
 */

import type { FieldId } from "../../domain/types.js";
import type { StageSettings } from "../../domain/stage-settings.js";
import type { StartBattleResult } from "../types.js";

export interface ConfirmBattleSettingsDeps {
  getPendingFieldId(): FieldId | null;
  getDraftSettings(): StageSettings;
  startBattle(fieldId: FieldId, stageSettings?: StageSettings): StartBattleResult;
  resetPending(): void;
}

export function createConfirmBattleSettings(deps: ConfirmBattleSettingsDeps) {
  return function confirmBattleSettings(): StartBattleResult {
    const fieldId = deps.getPendingFieldId();
    if (!fieldId) {
      return { code: "ValidationError", reason: "no pending field" };
    }
    const settings = deps.getDraftSettings();
    const result = deps.startBattle(fieldId, settings);
    if ("ok" in result && result.ok) {
      deps.resetPending();
    }
    return result;
  };
}
